export default function ProductCheckbox({ name, value, label, changesField }) {
  const is_included = changesField?.some((obj) => obj.field_name === name)
    ? 'custom-checkbox'
    : '';

  return (
    <>
      {is_included ? (
        <label class="custom-checkbox">
          <input
            name={name}
            type="checkbox"
            id={name}
            value={value}
            checked={Number(value) === 1}
            style={{ marginTop: '6px' }}
            readOnly
          />
          <span class="checkmark"></span>
          <span style={{ color: 'red' }}>{label}</span>
        </label>
      ) : (
        <>
          <input
            name={name}
            type="checkbox"
            id={name}
            value={value}
            style={{ marginTop: '6px' }}
            readOnly
          />
          {label}
        </>
      )}
    </>
  );
}
